<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table
            [request]="getRequest"
            [filtering]="filtering"
            [cols]="cols"
            [globalConditionalStyle]="globalConditionalStyle"
            [globalVisualTransform]="globalVisualTransform"
            actionButtonText="Añadir Control Sanitario"
            (actionButtonClick)="add()">

        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                    [showDuplicate]="true"
                    (duplicateRowButtonEvent)="duplicate(data.data)"
                    (editRowButtonEvent)="edit(data.data)"
                    (deleteRowButtonEvent)="show('delete', data.data)"
                    (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>
